import type { BaseInfo, ReportData, Type } from './types'
import { globalOptions } from './option'

async function report(type: Type, data: Record<string, any>) {
  const { extData, beforeReport } = globalOptions
  const reportData: ReportData = {
    type,
    base: getBaseInfo(),
    data,
    extData: extData?.()
  }
  if (beforeReport) {
    const res = await beforeReport(reportData, globalOptions)
    if (res === false) {
      // beforeReport显式返回false或者Promise<false>会取消发送
      return
    }
  }
  reportToServer([reportData])
}

function getBaseInfo(): BaseInfo {
  const { sessionId, appCode, appName, appVersion, userId } = globalOptions
  const getUserId = typeof userId === 'function' ? userId : () => userId
  console.log('typeof userId', typeof userId)
  return {
    sessionId: sessionId as string,
    appCode,
    appName: appName,
    appVersion: appVersion,
    userId: getUserId() || '',
    url: location.href,
    title: document.title,
    t: Date.now()
  }
}

function reportToServer(data: ReportData[]) {
  const { reportUrl } = globalOptions
  console.log('ready report to server, url:', reportUrl, 'reportData: ', data)
  if ('sendBeacon' in window.navigator) {
    sendByBeacon(reportUrl, data)
  } else {
    sendByImage(reportUrl, data)
  }
}

function sendByBeacon(url: string, data: ReportData[]) {
  const formData = new FormData()
  formData.append('v', JSON.stringify(data))
  navigator.sendBeacon(url, formData);
}

function sendByImage(url: string, data: ReportData[]) {
  const img = new Image()
  img.src = `${url}?v=${encodeURIComponent(JSON.stringify(data))}`
}

export { report }
